import React, { useEffect } from "react";
import SidebarSetting from "../../component/SidebarSetting/SidebarSetting";
import Navbar from "../../component/Navbar/Navbar";
import { GiScales } from "react-icons/gi";
import CreateUpdateUnitOfMeasure from "./createUpdateUnitOfMeasure";
import {
  deleteUOM,
  getAllUOMs,
  selectUnitOfMeasures,
} from "../../redux/features/unitOfMeasure/UnitOfMeasureSlice";
import { useDispatch, useSelector } from "react-redux";
import { MdDelete } from "react-icons/md";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";

const UnitOfMeasure = () => {
  const unitOfMeasures = useSelector(selectUnitOfMeasures);
  console.log(unitOfMeasures);
  const dispatch = useDispatch();

  const confirmDelete = (id, name) => {
    if (!id || !name) {
      toast.error("ID or Name is undefined");
      return;
    }
    confirmAlert({
      title: "Delete this Unit of measure",
      message: `Are you sure to delete the ${name}?`,
      buttons: [
        {
          label: "Delete",
          onClick: () => removeUOM(id),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };
  const removeUOM = async (id) => {
    await dispatch(deleteUOM(id));
    dispatch(getAllUOMs());
  };

  useEffect(() => {
    dispatch(getAllUOMs());
  }, [dispatch]);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1]">
      <div>
        <Navbar page="Settings" />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div className="lg:w-[30%] md:w-[39%] w-[35%] bg-white shadow-md">
          <SidebarSetting />
        </div>

        {/* Main Content */}
        <div className="flex-1 md:p-8 py-6 px-4 relative overflow-y-auto scrollbar-hide">
          {unitOfMeasures ? (
            <div className="mx-auto">
              <div className="flex  justify-start  gap-4 w-full flex-wrap">
                {unitOfMeasures?.map((unitOfMeasure, i) => (
                  <div
                    key={i}
                    className="md:w-[8rem] md:h-[8rem] w-[7rem] h-[7rem] bg-slate-300 rounded-2xl overflow-hidden flex items-center justify-center relative"
                  >
                    <GiScales className="w-full h-full object-cover text-white" />

                    <p className="absolute bg-[#20BEC6CC] w-full text-center md:text-[14px] text-[12px] md:bottom-8 bottom-6 font-semibold text-white py-1 capitalize">
                      {unitOfMeasure?.name}
                    </p>
                    <button
                      onClick={() =>
                        confirmDelete(unitOfMeasure._id, unitOfMeasure.name)
                      }
                      className="absolute text-white bg-[#fa3426cc] rounded-lg p-[4px] top-2 left-2"
                    >
                      <MdDelete className="size-4" />
                    </button>
                    <CreateUpdateUnitOfMeasure unitOfMeasure={unitOfMeasure} />
                  </div>
                ))}
              </div>
              <CreateUpdateUnitOfMeasure />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              <div className="md:w-[30rem] w-[25rem] lg:w-[38rem]  relative  lg:h-[29rem] h-[23rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
                <GiScales className="size-16 lg:size-36 md:size-24 mb-2" />
                <p className="text-[1rem] lg:text-[1.5rem] md:text-[1.35rem] font-inter-700 text-center">
                  You have no Unit of measure yet
                </p>
                <p className="text-[.8rem] md:text-[1rem] font-inter-400 text-center">
                  To add a Unit of measure, press the (+) button
                </p>
                <CreateUpdateUnitOfMeasure />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UnitOfMeasure;
